import React from 'react';
import { profile } from '../mock';

const stats = []; // replaced inline below for better alignment

const About = () => {
  return (
    <section id="sobre-mi" className="py-24 lg:py-32 relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-[24px] overflow-hidden shadow-[0_30px_80px_-40px_rgba(74,46,32,0.5)]">
            <img
              src={profile.about}
              alt="Sobre Karina"
              className="w-full h-full object-cover img-hover photo-no-watermark"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 lg:-right-10 bg-[#FAF4E8] border border-[#E8C9C0] rounded-2xl px-7 py-5 shadow-lg ring-1 ring-[#E8C9C0]/40">
            <p className="font-script text-[#B8806E] text-[28px] leading-none">
              “Escucho, no patologizo.”
            </p>
            <p className="mt-2 text-[12px] tracking-[0.18em] uppercase text-[#C49A8C]">
              Karina Negrín
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <span className="divider-mark" />
            <span className="eyebrow">Sobre mí</span>
          </div>

          <h2 className="font-serif text-[40px] lg:text-[56px] leading-[1.04] text-[#2E2A23] tracking-[-0.02em]">
            Soy psicóloga porque creo en
            <span className="italic text-[#B8806E]"> el sostén </span>
            de los procesos humanos.
          </h2>

          <div className="mt-7 space-y-5 text-[16px] leading-[1.8] text-[#2E2A23]/80 max-w-[640px] font-light">
            <p>{profile.longBio}</p>
            <p>
              Mi consultorio es un espacio donde lo que traés tiene lugar:
              cuerpo, vínculos, decisiones, mandatos, pérdidas, deseos. Trabajo
              con presencia y sensibilidad, con herramientas concretas y con la
              certeza de que ningún proceso se atraviesa solo.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-x-5 max-w-[600px]">
            <div className="border-l border-[#B8806E] pl-4 flex flex-col">
              <div className="font-serif text-[34px] lg:text-[42px] text-[#B8806E] leading-none">
                10+
              </div>
              <div className="mt-3 text-[11px] tracking-[0.18em] uppercase text-[#8A7E6E] leading-[1.5] min-h-[34px]">
                años<br />acompañando
              </div>
            </div>
            <div className="border-l border-[#B8806E] pl-4 flex flex-col">
              <div className="font-serif text-[34px] lg:text-[42px] text-[#B8806E] leading-none">
                300+
              </div>
              <div className="mt-3 text-[11px] tracking-[0.18em] uppercase text-[#8A7E6E] leading-[1.5] min-h-[34px]">
                mujeres<br />y familias
              </div>
            </div>
            <div className="border-l border-[#8FA08A] pl-4 flex flex-col">
              <div className="font-serif text-[28px] lg:text-[32px] text-[#6B7C66] leading-[1] italic">
                Mirada<br />integral
              </div>
              <div className="mt-3 text-[11px] tracking-[0.18em] uppercase text-[#8A7E6E] leading-[1.5] min-h-[34px]">
                sistémica · perinatal<br />feminista · apego
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-4">
            <div>
              <p className="text-[11px] tracking-[0.22em] uppercase text-[#8FA08A] mb-3">
                Formación académica
              </p>
              <div className="flex flex-wrap gap-2">
                {['Lic. en Psicología', 'Diplomada en Psicología Perinatal'].map((t) => (
                  <span
                    key={t}
                    className="px-4 py-2 rounded-full bg-[#E8DDC8] border border-[#C5B496] text-[12.5px] tracking-[0.04em] text-[#2E2A23]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[11px] tracking-[0.22em] uppercase text-[#8FA08A] mb-3">
                Formación complementaria
              </p>
              <div className="flex flex-wrap gap-2">
                {['Puericultora', 'Doula'].map((t) => (
                  <span
                    key={t}
                    className="px-4 py-2 rounded-full bg-transparent border border-[#C5B496] text-[12.5px] tracking-[0.04em] text-[#2E2A23]/80"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
